document.addEventListener('DOMContentLoaded', function () {

  new Swiper('.announcement-bar_main', {
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: false
    },
    slidesPerView: 1,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: false
    },
    allowTouchMove: true, 
    autoHeight: false,
    navigation: false,
    pagination: false
  });
  const Runeswiper = new Swiper(".column-slider", {
    slidesPerView: 2.2,
    spaceBetween: 19,
    freeMode: false,
    pagination: {
    el: ".swiper-pagination",
    clickable: true,
    },
    breakpoints: {
        
        768: {
          slidesPerView: 3.2,
          spaceBetween: 19,
        },
        1024: {
          slidesPerView: 4.4,
          spaceBetween: 19,
        },
    },
  });
  // Product slider
  const productThumb = new Swiper('.pl--product_thumb', {
    loop: true,
    slidesPerView: '4',          // variableWidth: true
    spaceBetween: 20,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },               // centerPadding equivalent
    freeMode: {
        enabled: true,
        momentum: true
    },
    watchSlidesProgress: true,
    slideToClickedSlide: true
  });

  const productSlider = new Swiper('.pl--product_slider', {
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    slidesPerView: 1,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
    thumbs: {
      swiper: productThumb
    }
  });
  new Swiper('.image-with-text-slider', {
    loop: true,
    effect: 'fade',
    autoHeight: false,
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    slidesPerView: 1,
    slidesPerGroup: 1,
    breakpoints: {
      1024: {
        slidesPerView: 1
      },
      600: {
        autoHeight: true,
        slidesPerView: 1
      },
      480: {
        slidesPerView: 1
      }
    }
  });
  const guardianSlider = new Swiper('.gaurdian-slider.slide', {
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    slidesPerView: 1,
    slidesPerGroup: 1,
    navigation: false,
    pagination: false,
    autoHeight: false,
    breakpoints: {
      1024: {
        slidesPerView: 1,
      },
      749: {
        slidesPerView: 1,
        autoHeight: false,
      },
      480: {
        slidesPerView: 1,
        autoHeight: false,
      },
    },
  });
  const eventProductsSlider = new Swiper('.event_products_wrapper', {
    loop: true,
    slidesPerView: 3,
    slidesPerGroup: 1,
    autoplay: false,
    navigation: {
      nextEl: '.event-next',
      prevEl: '.event-prev',
    },
    pagination: false,
    autoHeight: false,
    breakpoints: {
      0: {
        slidesPerView: 1,
        autoHeight: true,
      },
      750: {
        slidesPerView: 2,
        autoHeight: true,
      },
      1025: {
        slidesPerView: 3,
      },
    },
  });
/* --------- Review Slider --------- */

const reviewSlider = new Swiper('.review-slider', {
    loop: true,
    slidesPerView: 3,
    slidesPerGroup: 1,
    autoplay: false,
    navigation: {
      nextEl: '.review-next',
      prevEl: '.review-prev',
    },
    pagination: false,
    autoHeight: false,
    breakpoints: {
      0: {
        slidesPerView: 1,
        autoHeight: true,
      },
      750: {
        slidesPerView: 2,
        autoHeight: true,
      },
      1024: {
        slidesPerView: 3,
      },
      
    },
  });
  /* --------- Start Launch Slider --------- */
  const launchSlider = new Swiper('.launch-slider', {
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },

    slidesPerView: 1,
    slidesPerGroup: 1,

    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: false, // Slick pauseOnHover: false
    },

    navigation: false,
    pagination: false,

    autoHeight: true,

    breakpoints: {
      1024: {
        slidesPerView: 1,
      },
      749: {
        slidesPerView: 1,
        autoHeight: false,
      },
      480: {
        slidesPerView: 1,
        autoHeight: false,
      },
    },
  });
});




